import { ActivityEntityName, EntityQueueFieldSource, EntityViewDisplay, EntityViewSortDirection } from '@jms/model';
import { resolveColumnUiFields, toStageQueueFieldOptions } from '../../queue.field.options';
import { createEntityAdapter } from './entity.step.adapter';
import { QueueAdapterDeps, QueueStepAdapter } from './queue.step.adapter';

export const createEntityStageAdapter = (deps: QueueAdapterDeps): QueueStepAdapter =>
  createEntityAdapter(deps, {
    entity: ActivityEntityName.WorkOrder,
    entityLabel: 'Stage',
    resolveColumnOptions: map => {

      const jobMeta = map[ActivityEntityName.Job];
      return jobMeta ? toStageQueueFieldOptions(resolveColumnUiFields(jobMeta, true), true) : [];
    },
    defaultTable: () => ({
      display: EntityViewDisplay.Table,
      fixed: [],
      other: [
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.workOrders.workOrderNumber' }, name: 'Stage Number', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.customer' }, name: 'Customer', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.site' }, name: 'Site', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.status' }, name: 'Status', visible: true },
      ],
      sortBy: { source: EntityQueueFieldSource.Entity, path: 'entity.createdAt' },
      sortOrder: EntityViewSortDirection.Asc,
    }),
  });
